import { MaterialIcon } from "@website/icons/material";
import { deepCompare } from "@website/utils/deep-compare";
import { memo } from "react";

const Component = ({ availability }: { availability: number }) => {
  if (availability < 2) return null;
  return (
    <div className="bg-transparent-secondary flex flex-row items-center gap-2 rounded-lg p-4">
      <div className="size-[24px]">
        <MaterialIcon
          name="info"
          className="text-headline-5"
          variant="outlined"
        />
      </div>
      <span className="text-body-2">
        این اقامتگاه دارای واحد‌های مشابه است. امکانات و خدمات تمامی این واحدها
        یکسان بوده و تنها در دکور یا طبقه تفاوت دارند. واحد نهایی بر اساس موجودی
        پس از رزرو به شما اختصاص می‌یابد.
      </span>
    </div>
  );
};
export const VillaSimilarRoomsInform = memo(Component, deepCompare);
